/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { getFormatValues } from '../../../../lib/utils';

import plant from '../../../../../img/guest/plant.jpg';

import styles from '../../../../../styles/guest/sections/content/mobile.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Mobile = ({ active, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.active]: active,
            },
        ])}
    >
        <div className={styles.description}>
            <div className={styles.descriptionInner}>
                <p>
                    <FormattedMessage
                        defaultMessage="These days, everything happens on mobile. <strong>Micromags</strong> are the best way to put an interactive experience directly in the hands of your audience, leaving them with a rich and lasting{nbsp}impression."
                        description="Guest content - mobile description 1"
                        values={getFormatValues()}
                    />
                </p>
                <p>
                    <strong>
                        <FormattedMessage
                            defaultMessage="That printed magazine feeling, on their phone{nbsp}screen."
                            description="Guest content - mobile description 2"
                            values={getFormatValues()}
                        />
                    </strong>
                </p>
            </div>
        </div>
        <div className={styles.phone}>
            <div className={styles.frame}>
                <div className={styles.frameContent}>
                    <h2>
                        <FormattedMessage
                            defaultMessage="The magazine experience, at your fingertips"
                            description="Guest content - mobile title"
                            values={getFormatValues()}
                        />
                    </h2>
                    <img src={plant} alt="plant" />
                </div>
            </div>
        </div>
        <div className={styles.spacer} />
    </div>
);

Mobile.propTypes = propTypes;
Mobile.defaultProps = defaultProps;

export default Mobile;
